export enum ModuleActionDispatchTypes {
  MODULE_FAIL = "MODULE_FAIL",
  MODULE_INVOKE = "MODULE_INVOKE",
  MODULE_SUCCESS = "MODULE_SUCCESS",
}
